import API from "../../api/Api.service";
import { lessonLanguage } from "../../utils/lessonLanguage";

const getDashboard = async (data = {}) => {
  const res = await API.get("/dashboard", {
    ...data,
    params: { ...data.params, language: lessonLanguage(data.params?.language) },
  });
  return res.data;
};

const courseViewData = async (courseId, language = "en") => {
  const res = await API.get(`/course/${courseId}/lessons/meta`, {
    params: { language },
  });
  return res.data;
};

const filterDataHome = async (type, query) => {
  const res = await API.get(`/search/${type}`, {
    params: {
      q: query,
    },
  });

  return res.data;
};

const postEnrollCourse = async (courseId) => {
  // The versioned endpoint is idempotent: a retry returns the existing
  // enrollment instead of failing with the legacy route's "Already enrolled"
  // response. Let request errors propagate so the caller cannot continue to the
  // course map after a failed enrollment.
  const res = await API.post(`/v1/enroll_course/${courseId}`);
  return res.data;
};

const DashboardService = {
  getDashboard,
  courseViewData,
  filterDataHome,
  postEnrollCourse,
};

export default DashboardService;
